export default function OwnLocation({setData, form}) {

    return (
        <>
            <div className={'ctrow'}>
                <div className={'col-3'}>
                    <label>Postcode/ZIP</label>
                    <input type={"text"} className={"form-control"} placeholder={"Postcode/ZIP"}
                           value={form?.zip ?? ''}
                           onChange={(e) => setData({zip: e.target.value})}
                    />
                    <small>Please provide your postcode for accurate fare calculation.</small>
                </div>
                <div className={'col-6'}>
                    <label>City</label>
                    <input type={"text"} className={"form-control"} placeholder={"City"}
                           value={form?.city ?? ''}
                           onChange={(e) => setData({city: e.target.value})}
                    />
                </div>
            </div>
            <div style={{clear: 'both'}}></div>
            <div className={'ctrow'}>
                <div className={'col-6'}>
                    <label>Street</label>
                    <input type={"text"} className={"form-control"} placeholder={"Street"}
                           value={form?.street ?? ''}
                           onChange={(e) => setData({street: e.target.value})}
                    />
                </div>
                <div className={'col-3'}>
                    <label>House number</label>
                    <input type={"text"} className={"form-control"} placeholder={"House number"}
                           value={form?.housenumber ?? ''}
                           onChange={(e) => setData({housenumber: e.target.value})}
                    />
                </div>
            </div>
            <div style={{clear: 'both'}}></div>
            <div className={'ctrow'}>
                <div className={'col-6'}>
                    <label>Company</label>
                    <input type={"text"} className={"form-control"} placeholder={"Company"}
                           value={form?.company ?? ''}
                           onChange={(e) => setData({company: e.target.value})}
                    />
                </div>
            </div>
            <div style={{clear: 'both'}}></div>
        </>
    );
}